import axios from 'axios'
import { Message, MessageBox } from 'element-ui'  //导入element-ui组件库
 
// 创建axios的对象
const instance = axios.create({
    baseURL: "https://admin.zxbiotech.cn/api",  //配置固定域名
    // timeout: 10000
})

// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容

// 封装get和post请求
export function get(url, params) {
    return instance.get(url, {params})
}
 
export function post(url, data) {
    return instance.post(url, data)
}

export default instance;



// WEBPACK FOOTER //
// ./src/request/http.js